/*** IMPORTS FROM imports-loader ***/


'use strict'

var now = require('./now')

/**
 * Replacement for PerformanceTiming.navigationStart for the case when
 * performance.now is not implemented.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming.navigationStart
 *
 * @type {Number}
 * @api private
 */
exports.navigationStart = now()




//////////////////
// WEBPACK FOOTER
// ../~/animation-frame/lib/performance-timing.js
// module id = 150
// module chunks = 3